import { render, staticRenderFns } from "./ModelingRulesList.vue?vue&type=template&id=65b4ece0&scoped=true&"
import script from "./ModelingRulesList.vue?vue&type=script&lang=js&"
export * from "./ModelingRulesList.vue?vue&type=script&lang=js&"
import style0 from "./ModelingRulesList.vue?vue&type=style&index=0&id=65b4ece0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b4ece0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VList,VListItem,VListItemContent,VListItemTitle,VRow,VSpacer,VTooltip})
